module.exports = __webpack_public_path__ + "static/media/live_session.0de7e187.svg";